import React, { useState, useEffect } from 'react';
import { DependenteEntidade } from '../../../entidades';
import { Alerta, Box, TipoAlerta } from '@intechprev/componentes-web';
import { DependenteService } from '../../../services';

interface IProps {
  SqPlano: number;
}

export const Dependentes: React.FC<IProps> = ({
  SqPlano
}) => {

  const [AlertText, setAlertText] = useState<string>("");
  const [Dependentes, setDependentes] = useState<Array<DependenteEntidade> | undefined>(new Array<DependenteEntidade>());

  useEffect(() => {
    (async () => {
      try {
        const Dependentes = await DependenteService.BuscarPorPlano(SqPlano);
        setDependentes(Dependentes);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }

    })();
  }, []);

  if (Dependentes !== undefined) {
    if (Dependentes.length > 0) {
      return (
        <Box titulo={"Beneficiários"}>
          <div className={"table-responsive"}>
            <table className={"table table-striped table-sm"}>
              <thead>
                <tr>
                  <th>Grau de Parentesco</th>
                  <th>Nome</th>
                  <th>Sexo</th>
                  <th>Data de Nascimento</th>
                  <th>CPF</th>
                  <th>Atualizado em</th>
                </tr>
              </thead>
              <tbody>
                {Dependentes.map((dependente: DependenteEntidade, index: number) => {
                  const cor = index % 2 === 0 ? "table-active" : "";
                  return (
                    <tr key={index} className={cor}>
                      <td>
                        {dependente.DS_GRAU_PARENTESCO}
                      </td>
                      <td>
                        {dependente.NO_PESSOA}
                      </td>
                      <td>
                        {dependente.IR_SEXO}
                      </td>
                      <td>
                        {dependente.DT_NASCIMENTO}
                      </td>
                      <td>
                        {dependente.NR_CPF}
                      </td>
                      <td>
                        {dependente.DT_INCLUSAO}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </Box>
      );
    }

    if (Dependentes.length === 0) {
      return (
        <Alerta tipo={TipoAlerta.info}
          mensagem={"Não há dependentes cadastrados para esse plano"}
        />
      );
    }
  }

  if (AlertText !== "") {
    return (
      <Alerta tipo={TipoAlerta.danger}
        mensagem={AlertText}
      />
    );
  }

  return null;
}